import { reactive, toRefs, ref, computed } from '@vue/composition-api';
import debounce from 'lodash/debounce';

import checkEmailDomain from '@/js/services/api/checkEmailDomain';
import { NO_VALID_EMAIL_AVAILABILITY } from '@/js/helpers/globalConst';

import { userCheckEmailAvailability } from '@/js/repositories/User';

export default () => {
  const params = reactive({
    email: '',
    emailChecking: false,
    isEditEmail: false,
  });

  const emailCheckingList = ref([]);

  const addEmailChecking = (name) => {
    emailCheckingList.value.push(name);
  };

  const removeEmailChecking = (name) => {
    const index = emailCheckingList.value.indexOf(name);
    if (index >= 0) {
      emailCheckingList.value.splice(index, 1);
    }
  };

  const checkEmailAvailability = email => new Promise((resolve, reject) => {
    addEmailChecking('checkEmailAvailability');
    userCheckEmailAvailability(email)
      .then(() => {
        resolve(true);
      })
      .catch((e) => {
        if (e.code && e.code === NO_VALID_EMAIL_AVAILABILITY) {
          reject(e.message);
        }
        resolve(false);
      })
      .finally(() => {
        removeEmailChecking('checkEmailAvailability');
      });
  });

  const checkEmailDomainHandler = email => new Promise((resolve) => {
    addEmailChecking('canCheckEmailDomain');
    return checkEmailDomain.get(email)
      .then(res => resolve(res))
      .catch(() => resolve(false))
      .finally(() => {
        removeEmailChecking('canCheckEmailDomain');
      });
  });

  const canCheckEmailAvailability = email => new Promise((resolve, reject) => {
    userCheckEmailAvailability(email)
      .then(() => {
        resolve(true);
      })
      .catch((e) => {
        if (e.code && e.code === NO_VALID_EMAIL_AVAILABILITY) {
          reject(e.message);
        }
        resolve(false);
      })
      .finally(() => {
        params.emailChecking = false;
      });
  });

  // eslint-disable-next-line prefer-arrow-callback
  const canCheckEmailDomain = debounce(function checkEmailDomainMethodFunc(value, resolve) {
    params.emailChecking = true;
    return checkEmailDomain.get(value)
      .then(() => {
        params.isEditEmail = true;
        return resolve(true);
      })
      .catch(() => resolve(false))
      .finally(() => {
        params.emailChecking = false;
      });
  }, 500);

  const isEmailChecking = computed({
    get: () => !!emailCheckingList.value.length,
    set: () => {},
  });

  return {
    ...toRefs(params),
    isEmailChecking,
    checkEmailAvailability,
    checkEmailDomainHandler,
    addEmailChecking,
    removeEmailChecking,
    canCheckEmailDomain,
    canCheckEmailAvailability,
  };
};
